import { Checkbox, Divider, Grid, Stack, Typography } from '@mui/material';
import { communicationTemplates } from 'common/constants/communicationType';
import useFlexBoxStyles from 'common/flexBox';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsKey from '../utils/settingsTypes';

const CommunicationPreferences = (props) => {
    const { communicationPreferences, toggleChange, smsCommunicationEnabled } = props;
    const { t } = useTranslation();
    const { classes: flexBox } = useFlexBoxStyles();

    const handleCheckChange = useCallback(
        (type, event) => {
            const checked = event.target.checked;
            const name = event.target.name;
            const oldValue = communicationPreferences[name] || ['email'];
            let updatedTypes;
            if (checked) {
                updatedTypes = [...new Set([...oldValue, type])];
            } else {
                updatedTypes = oldValue.filter((item) => item !== type);
            }

            const newValue = {
                ...communicationPreferences,
                [name]: updatedTypes,
            };

            toggleChange(SettingsKey.COMMUNICATION_PREFERENCES, newValue);
        },
        [communicationPreferences, toggleChange],
    );

    const getCommunicationPreferences = useCallback(
        (type) => {
            return communicationPreferences[type] || ['email'];
        },
        [communicationPreferences],
    );

    return (
        <Stack className={flexBox.padding20}>
            <Typography variant="subtitle1" fontWeight={600} className={flexBox.paddingBottom2}>
                {t('settings.communications.communicationsPreferences')}
            </Typography>

            <Grid container alignItems="center">
                <Grid item xs={8}>
                    <Typography variant="subtitle1" fontWeight={500}>
                        {t('settings.communications.types')}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle1" fontWeight={500}>
                        EMAIL
                    </Typography>
                </Grid>
                {smsCommunicationEnabled && (
                    <Grid item xs={2}>
                        <Typography variant="subtitle1" fontWeight={500}>
                            SMS
                        </Typography>
                    </Grid>
                )}
            </Grid>

            <Divider />

            {communicationTemplates.map((communicationTemplate) => (
                <Grid container key={communicationTemplate.templateName} alignItems="center">
                    <Grid item xs={8}>
                        <Typography variant="subtitle1" fontWeight={400}>
                            {t(`settings.communications.${communicationTemplate.templateName}`)}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Checkbox
                            checked={(communicationTemplate.supportedChannels.includes('email') && getCommunicationPreferences(communicationTemplate.templateName)?.includes('email')) ?? false}
                            onChange={(e) => handleCheckChange('email', e)}
                            name={communicationTemplate.templateName}
                            color="primary"
                            size="small"
                            disabled={!communicationTemplate.supportedChannels.includes('email')}
                        />
                    </Grid>
                    {smsCommunicationEnabled && (
                        <Grid item xs={2}>
                            <Checkbox
                                checked={(communicationTemplate.supportedChannels.includes('sms') && getCommunicationPreferences(communicationTemplate.templateName)?.includes('sms')) ?? false}
                                onChange={(e) => handleCheckChange('sms', e)}
                                name={communicationTemplate.templateName}
                                color="primary"
                                size="small"
                                disabled={!communicationTemplate.supportedChannels.includes('sms')}
                            />
                        </Grid>
                    )}
                </Grid>
            ))}
        </Stack>
    );
};

export default CommunicationPreferences;
